module.exports = __parcel__import__.meta.resolve("a2DY4");